import { render, staticRenderFns } from "./register-pos-form.vue?vue&type=template&id=580cdb32&scoped=true"
import script from "./register-pos-form.vue?vue&type=script&lang=js"
export * from "./register-pos-form.vue?vue&type=script&lang=js"
import style0 from "./register-pos-form.vue?vue&type=style&index=0&id=580cdb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cdb32",
  null
  
)

export default component.exports